import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import _Portal from 'reakit/Portal';

var Portal = styled(process.env.NODE_ENV === 'test' ? 'div' : _Portal).withConfig({
  displayName: "styled__Portal",
  componentId: "sc-16k4rag-0"
})(["", ";"], theme('fannypack.Portal.base'));

export default Portal;
export { Portal };
